export const environment = {
  production: true,
  env: 'prod',
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: 'AIzaSyCU5VMd3-lpzaAs10eZmLdnhRGOkgrydkM',
    authDomain: 'groovy-ace-198213.firebaseapp.com',
    databaseURL: 'https://groovy-ace-198213-default-rtdb.firebaseio.com',
    projectId: 'groovy-ace-198213',
    storageBucket: 'groovy-ace-198213.appspot.com',
    messagingSenderId: '83454881566',
    appId: '1:83454881566:web:21fbb4c764c89428f7a30f',
    measurementId: 'G-TTDNT37K47',
  },
  basePathRooms_chat: 'chat_personal_inbox_new/',
  basePathUnreadStaff_chat: 'unread_staff_new/',
  api: 'https://api.tsolife.com/api',
  host: 'api.tsolife.com',
  basePathRooms: 'chat_personal_inbox/',
  basePathUnreadStaff: 'unread_staff/',
  maps: 'AIzaSyAPA-05Kx-Rb-B65imzmpcjItDv07pn8J8',
  oktaConfig: {
    clientSecret: '5zNi7nhRIUNuSgSf1YjcikK4KLrBPkRpopDLi7hm',
    clientId: '984c740f-cc09-4e14-b0b2-c2716e08c8f7',
  },
  externalGallery: {
    unsplash: {
      api: 'https://api.unsplash.com',
      token: 'ga4wr8LmTbcyj4CsNBoioJIF-t_FVxwPGk4C3mL2QDA',
    },
  },

  benchmarkCorpId: '1bf695e8-d904-4f54-9c0d-00438d139cac',
  civitasCorpId: '1ec64086-6ff2-472c-9f14-1491a743b198',
  migFormTestCorporationId: '2135b89a-e812-4972-a0ba-b725fcd0073a',
  assisstedLivingMigFormId: '8050418b-b861-11ed-afee-0299b64a2891',
  memoryCareMigFormId: 'c61c8d16-b861-11ed-afee-0299b64a2891',
  clientSecret: '5zNi7nhRIUNuSgSf1YjcikK4KLrBPkRpopDLi7hm',
  clientId: '984c740f-cc09-4e14-b0b2-c2716e08c8f7',
  relativeTagsFieldMigForm: 'a004e6fe-b861-11ed-afee-0299b64a2891',
  brookdaleCorpId: 'e3a968e8-af1b-4871-b2de-307735864e53',
  commonwealthCorpId: '8951690d-139d-45ad-b8d6-518fcd5dbad4',
  sunriseCorpId: '12db85f2-ac27-486a-8bb2-6f36ee881712',
  maxwellCorpId: '1170a4e6-127d-4f56-b294-34f6844fe0fb',
  seniorResourceGroupId: '65040b8f-febb-494e-8dc8-89826974a894',
  SRGCorpId: '65040b8f-febb-494e-8dc8-89826974a894',
  harmonyCorpId: '6b18c82e-1ca4-4be0-bc13-a54d372e0c6c',
  jaybirdCorpId: '07b3924d-1238-45a3-a8cc-4a1220d49379',
  primroseCorpId: '8a1fac86-de35-430b-8371-a44117c2eb0f',
  maplewoodCorpId: '724fd32f-5448-4177-b081-2056395da49a',
  sagoraCorpId: '714af556-011c-4ede-b179-f35d41f0e4a1',
  trilogyCorpId: 'f0b4e575-d3ce-413b-aebb-26425fc3915a',
  sunshineRetirementLivingInd: '68009d1f-39b1-4c39-b96f-f06b1204d7d2',
  merrillGardensInd: 'd165029b-2d80-49d5-8da1-de6173a3e8ab',
  salmonHealthCorpId: '66cfbc4f-ad21-4ad5-a9cf-f0954b766567',
  wellmoreOfDanielIslandLLCCommunityId: '57b6c7bf-60d2-40a9-ae47-5fb73a29289a',
  foxRidgeChenalCommunityId: '90240c2f-d95c-4201-a174-559a1ce9c67e',
  tribuneSpreadSheetUrl:
    'https://docs.google.com/spreadsheets/d/1CNN_pFeilp8MS0SopFhh_gC5fdb_vuAhXObfOgvqy84/edit#gid=1055691707',
  base: 'https://tsolife.com/',
  communities: {
    premiumContent: 'fc5fccfd-3b91-4d37-b9cc-781166a5d80a',
  },
  pdfPrintHost: 'https://pdf2.tsolife.com',
  batch: 'requestDocuments',
};
